import React from "react";
import { Skeleton } from "antd";
import { Row, Col } from "reactstrap";

const DashboardSkeleton = () => {
    return (
        <div className="dashboard-container" style={{ padding: "20px" }}>
            <Row className="dashboard mb-4">
                <Col md={12} sm={12}>
                    <Row>
                        {[1, 2, 3, 4].map((item) => (
                            <Col md={3} sm={6} key={item}>
                                <div className="p-4 bg-white rounded shadow-sm border">
                                    <Skeleton active avatar={{ shape: "circle", size: "large" }} paragraph={{ rows: 2 }} title={false} />
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md={8} sm={12}>
                    <div className="p-4 bg-white rounded shadow-sm border" style={{ height: "300px" }}>
                        <Skeleton.Node active style={{ width: '100%', height: '250px' }} />
                    </div>
                </Col>
                <Col md={4} sm={12}>
                    <div className="p-4 bg-white rounded shadow-sm border" style={{ height: "300px" }}>
                        <Skeleton active paragraph={{ rows: 6 }} />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default DashboardSkeleton;
